export const languages = {
  en: "en",
  ko: "ko",
} as const;

export type Languages = typeof languages[keyof typeof languages];

export const TranslationKey = {
  "페이지 불러오는 중...": "페이지 불러오는 중...",
  "앱 설정 조회 중...": "앱 설정 조회 중...",
  "바로가기 링크 가져오는 중...": "바로가기 링크 가져오는 중...",
  "로딩 중...": "로딩 중...",
  "사용자 정보 가져오는 중...": "사용자 정보 가져오는 중...",
  "앗, 이런!": "앗, 이런!",
  "새로 고침": "새로 고침",
  "게스트 사용자는 해당 앱을 사용할 수 없습니다.":
    "게스트 사용자는 해당 앱을 사용할 수 없습니다.",
  "뒤로 가기": "뒤로 가기",
  "처음이신가요?": "처음이신가요?",
  "앱 사용이 처음인 경우, 최초 1회 사용 동의가 필요합니다.":
    "앱 사용이 처음인 경우, 최초 1회 사용 동의가 필요합니다.",
  "사용 동의": "사용 동의",
  "데이터가 없습니다.": "데이터가 없습니다.",
  "관리자에게 문의해 주세요.": "관리자에게 문의해 주세요.",
  처음으로: "처음으로",
  "Teams AuthToken 확보 중...": "Teams AuthToken 확보 중...",
} as const;
